import { pairsStore } from "@/shared/stores/PairsStore";
import type { PairMessage } from "@cronika/proto/common/trading_pb";

export const usePairs = () => {
  return {
    allPairs: pairsStore.pairs,
    selectedPairs: pairsStore.selectedPairs,
    favoritePairs: pairsStore.favoritePairs,
    activePair: pairsStore.activePair,

    updateSelectedPairs: (newPairs: Parameters<typeof pairsStore.setSelectedPairs>[0]) =>
      pairsStore.setSelectedPairs(newPairs),
    updateActivePair: (pair: Parameters<typeof pairsStore.setActivePair>[0]) => pairsStore.setActivePair(pair),
    addPair: (pair: Parameters<typeof pairsStore.addPair>[0]) => pairsStore.addPair(pair),
    removePair: (pairId: string) => pairsStore.removePair(pairId),
    selectPairAsActive: (pairId: string) => pairsStore.selectPairAsActive(pairId),
    replaceActivePair: (pair: Parameters<typeof pairsStore.replaceActivePair>[0]) => pairsStore.replaceActivePair(pair),
    toggleFavorite: (pair: PairMessage) => pairsStore.toggleFavorite(pair),
    isFavorite: (pairId: string) => pairsStore.isFavorite(pairId),
  };
};
